import { DriveItemId } from '@/drive/entities/DriveItemId';

export function insertTemporaryItems<T extends { id: DriveItemId }>(
  siblings: T[],
  temporaryItems: T[],
  precedingNodeIdByTempId: Map<DriveItemId, DriveItemId>,
): T[] {
  const result = [...siblings];
  const itemsOnTop: T[] = [];

  temporaryItems.forEach((item) => {
    const precedingNodeId = precedingNodeIdByTempId.get(item.id);
    const precedingIndex = result.findIndex((sibling) => sibling.id === precedingNodeId);

    if (precedingNodeId !== undefined && precedingIndex !== -1) {
      result.splice(precedingIndex + 1, 0, item);
    } else {
      itemsOnTop.push(item);
    }
  });

  return [...itemsOnTop, ...result];
}
